<template>
    <k-editor-form v-if="event">

      <template #left>
        <k-layout>
          <k-flex c6>
            <k-layout>
              <k-flex :c8="source_is_alternatives" :c12="!source_is_alternatives">
                <k-autocomplete :disabled="disable_event_group_edit"  v-bind:items="sorted_inputs" v-model="event.event_group.channel_id" placeholder="Select source" clearable item-text="title" item-value="id" label="Source" @change="clear_alternative"></k-autocomplete>
              </k-flex>
              <k-flex c4 v-if="source_is_alternatives">
                <template v-if="event.event_group.channel_id">
                  <k-autocomplete :items="alternatives" :disabled="disable_event_group_edit" placeholder="Alternative" label="Alternative"
                        item-text="title" item-value="alternative" clearable v-model="event.event_group.system_meta.alternative">
                  </k-autocomplete>
                </template>
              </k-flex>
            </k-layout>
          </k-flex>
          <k-flex c6>
            <k-layout>
              <k-flex :c8="is_output_inputs" :c12="!is_output_inputs">
                <k-autocomplete  v-bind:items="sorted_outputs" v-model="output" placeholder="Select destination" item-text="title" item-value="id" label="Destination" required :rules="[v => !!v || 'Item is required']" @change="clear_output_input">
                </k-autocomplete>
              </k-flex>
              <k-flex c4 v-if="is_output_inputs">
                <k-autocomplete v-model="event.system_meta.input" clearable label="Input" placeholder="Input" :items="output_inputs" item-text="title" item-value="id">
                </k-autocomplete>
              </k-flex>
            </k-layout>
          </k-flex>
        </k-layout>

        <template v-if="output_is_transcoder && is_output_inputs">
          <k-layout>
            <k-flex c6>&nbsp;</k-flex>
            <k-flex c6>
              <event-select label="Select event to link" v-model="event.system_meta.linked_event" :filters="event_select_filters" :filter-function="event_select_filter_events"></event-select>
            </k-flex>
          </k-layout>
        </template>

        <k-divider></k-divider>

        <component v-for="elem in left_side" :key="elem.name" v-bind:is="elem.type" v-bind="elem" v-model="event">
          <k-flex :class="row_classes(elem.childs)" v-for="celem in elem.childs" :key="celem.key">
            <component v-bind:is="celem.type" v-bind="celem" v-model="event"></component>
          </k-flex>
        </component>

        <div v-if="event && srt_outputs.length > 0" style="margin-top: 0px;">
          <div v-for="output in srt_outputs" :key="output.id">
            <div>{{output.title || output.id}}:</div>
            <k-layout>
              <k-flex c4>
                <k-text-field placeholder="Latency" label="Latency (ms)" type="number" v-model="event.system_meta.srt_latency[output.id]"></k-text-field>
              </k-flex>
            </k-layout>
          </div>
        </div>
      </template>

      <template #right>
        <k-layout>
          <k-flex c6>
            <date-time-picker :disabled="disable_event_group_edit" label="Kickoff time" first-day-of-week="1" time-format="HH:mm" v-model="event.times.start_time"></date-time-picker>
          </k-flex>
          <k-flex c6>
            <date-time-picker :disabled-before="event.times.start_time" label="End time" first-day-of-week="1" time-format="HH:mm" v-model="event.times.end_time" :time-buttons="time_buttons" :rules="end_time_validation_rules" :clear-time="!id && !is_clone" ref="end_time" :modified.sync="end_time_modified"></date-time-picker>
          </k-flex>
        </k-layout>

        <k-autocomplete :hint="'Duration: '+calculatedDuration" persistent-hint v-bind:items="beforeTimes" v-model="event.offset" item-value="value" item-text="label" label="Open Before"></k-autocomplete>

        <k-divider></k-divider>

        <k-layout>
          <k-flex c6>
            <date-time-picker label="Publish start" first-day-of-week="1" time-format="HH:mm" v-model="event.times.publish_start_time"></date-time-picker>
          </k-flex>
          <k-flex c6>
            <date-time-picker :disabled-before="event.times.publish_start_time" label="Publish end" first-day-of-week="1" time-format="HH:mm" v-model="event.times.publish_end_time" :time-buttons="publish_time_buttons" :modified.sync="publish_end_time_modified"></date-time-picker>
          </k-flex>
        </k-layout>


        <k-layout v-if="$is_admin() && event">
          <k-flex c4>
            <contract-select v-model="event.system_meta.billing" name="contract" label="Billing contract" v-bind:output_channel="output_channel"></contract-select>
          </k-flex>
          <k-flex c4>
            <k-autocomplete v-model="event.system_meta.billing.status" name="billing_status" label="Billing status" placeholder="Billing status" :items="billing_statuses" item-text="label" item-value="value">
            </k-autocomplete>
          </k-flex>
          <k-flex c4>
            <k-text-field v-model="event.system_meta.billing.sum" label="Billing sum" placeholder="Billing sum" type="number"></k-text-field>
          </k-flex>
          <k-flex c4>
            <k-text-field v-model="event.system_meta.billing.expenses_sum" label="Expenses sum" placeholder="Expenses sum" type="number"></k-text-field>
          </k-flex>
        </k-layout>

        <k-layout v-if="$is_admin()">
          <k-flex>
            <k-text-field textarea v-model="event.system_meta.billing.info" label="Billing information" title="Billing information"></k-text-field>
          </k-flex>
        </k-layout>

        <k-layout v-if="current_account_email && $is_admin()">
          <k-flex c6>
            <k-checkbox label="Todo list" v-model="todo"></k-checkbox>
          </k-flex>
          <k-flex c6>
            <k-autocomplete placeholder="Todo status" label="Todo status" :items="todo_statuses" v-model="todo_status">
            </k-autocomplete>
          </k-flex>
        </k-layout>


        <component v-for="elem in right_side" :key="elem.name" v-bind:is="elem.type" v-bind="elem" v-model="event">
          <k-flex :class="row_classes(elem.childs)" v-for="celem in elem.childs" :key="celem.key">
            <component v-bind:is="celem.type" v-bind="celem" v-model="event"></component>
          </k-flex>
        </component>
        <k-divider v-if="id"></k-divider>


        <k-text-field
          label="UUID"
          :value="id"
          readonly
          v-if="id">
        </k-text-field>
        <k-text-field
          label="Recording UUID"
          :value="event.event_group.uuid"
          readonly
          v-if="id && $is_admin()">
        </k-text-field>
        <k-text-field
          label="External Id"
          :value="event.external_id"
          readonly
          v-if="event.external_id">
        </k-text-field>

        <p v-if="page_url">
          Page url: <a :href="page_url" target="_blank">{{page_url}}</a>
        </p>

      </template>

      <template #right-buttons>
        <k-btn size="m" flat @click="reset">Reset</k-btn>
        <k-btn size="m" color="danger" v-show="is_edit && event.state != 'archived'" @click="changeState('archived')">Archive</k-btn>
        <k-btn size="m" color="danger" v-show="is_edit && event.state == 'archived'" @click="changeState('active')">Unarchive</k-btn>
        <k-btn size="m" color="primary" v-show="is_edit" @click="clone()">Clone</k-btn>
        <k-btn size="m" color="success" v-show="!disable_event_group_edit" @click="save('none')">Save</k-btn>
        <k-btn size="m" color="success" v-show="is_edit && disable_event_group_edit" @click="save('none')">Save</k-btn>
        <k-btn size="m" color="success" v-show="!is_edit && disable_event_group_edit" @click="save('new')">Save</k-btn>
        <k-btn size="m" color="success" v-show="!is_edit && !disable_event_group_edit" @click="save('new')">Save and new</k-btn>
        <k-btn size="m" color="success" v-show="!disable_event_group_edit" @click="save('close')">Save and close</k-btn>

      </template>
    </k-editor-form>
</template>

<script>
import moment from 'moment';
require("moment-duration-format");


import * as FormItems from '@/components/form_items'
import { mapGetters } from 'vuex'
import ChannelModel from '@/models/channel.js'
import EventModel from '@/models/event.js'
import SettingsModel from '@/models/settings.js'
import DateTimePicker from '../../DateTimePicker';
import DatePicker from '../../DatePicker';
import Vue from 'vue';
import TextArea from '../../form_items/TextArea.vue';

export default {
  props: {
    id: null,
    event_group: null,
    scrollable: {
      type: Boolean,
      default: true
    },
    height: {
      type: [Number, String],
      default: 532
    },
    disable_event_group_edit: {
      type: Boolean,
      default: false
    },
    disable_get_profile: {
      type: Boolean,
      default: false
    }
  },
  components:
    {
    TextArea,
    DateTimePicker,
    DatePicker,
    ...FormItems
    },
  data () {
    var ch = this.$cloudserver.channel(this.get_channel(this.$route));
    return {
      valid: true,
      ws_channel: ch,
      event: this.convertEvent(ch.data),
      output: _.get(ch, "data.channel_id"),
      beforeTimes: EventModel.before_times(),
      todo_statuses: ["watch","ready"],
      billing_statuses: [
        {label: "Billed", value: "billed"},
        {label: "Not billed", value: "not_billed"}
      ],
      current_account: undefined,
      time_buttons: [
        {text: "3H", value: 3*60*60, action: "add", to: () => { return this.event.times.start_time }},
        {text: "6H", value: 6*60*60, action: "add", to: () => { return this.event.times.start_time }},
        {text: "12H", value: 12*60*60, action: "add", to: () => { return this.event.times.start_time }}
      ],
      publish_time_buttons: [
        {text: "End of kickoff day", icon: "keyboard_tab", action: "end_of_day", to: () => { return this.event.times.start_time }},
      ],
      end_time_validation_rules: [
        (value) => {
          if (this.event.times.start_time && value) {
            if (moment(this.event.times.start_time).isSameOrAfter(value)) {
              return "End time must be after start time!";
            }
          }
          return true;
        }
      ],
      end_time_modified: false,
      publish_end_time_modified: false
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") this.event = this.convertEvent(newVal, oldVal);
      },
      deep: true
    },
    '$route' (to, from) {
      if((typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) || (typeof(from.meta.new) != "undefined" && to.name == from.meta.new)) {
        // The id prop is not yet updated when this watcher runs, so use the target route's id
        this.ws_channel = this.$cloudserver.channel(this.get_channel(to, to.params.id || null));
        this.ws_channel.join();
        this.convertEvent(this.ws_channel.data);
      }
    },
    "event.times.start_time" (newVal, oldVal) {
      if(newVal != oldVal && oldVal && this.event) {
        if(!this.end_time_modified) {
          this.event.times.end_time = moment(newVal).add((moment(this.event.times.end_time).unix() - moment(oldVal).unix()),"seconds").toDate();
        } else {
          this.$refs.end_time.validate();
        }
        if(!this.publish_end_time_modified && moment(this.event.times.publish_end_time).unix() != 0) this.event.times.publish_end_time = moment(newVal).add((moment(this.event.times.publish_end_time).unix() - moment(oldVal).unix()),"seconds").toDate();
      }
    },
    "$store.state.account": {
      handler(newVal, oldVal) {
        if(typeof(newVal) == "object" && typeof(newVal.meta) == "object" && typeof(newVal.meta.default_destination) != "undefined" && !this.output && !this.is_edit) {
          var channel = ChannelModel.channel_by_uuid(newVal.meta.default_destination);
          if(typeof(channel) == "object") {
            this.output = channel.id;
          }
        }
        if (typeof(newVal) == "object") {
          this.current_account = newVal;
        }
      },
      deep: true
    }
  },
  created() {
    this.ws_channel.join();
    if(!this.disable_get_profile) this.$store.dispatch("get_profile");
  },
  computed: {
    event_select_filters () {
      // FIXME: Miksi tämä ajetaan monta kertaa kun output kanava valitaan.....
      var kick_off_time = moment(this.event.times.start_time).unix();
      var ret = {
        "channel_id": [this.output],
        "daterange": {
          "start": kick_off_time,
          "end": kick_off_time + (60 * 60 * 24 * 1), // Yksi kuukausi eteenpäin
        },
        "states": ["active"],
        "limit": 100,
        "order_by": [{"cached_start_time":"desc"}, {"uuid": "desc"}]
      };
      return ret;
    },

    srt_outputs () {
      let outputs = this.outputs_list

      outputs = _.filter(outputs, function(output) {
        if (output.type != "srt") return false
        if (typeof(output.latency) == "undefined") return false
        if (typeof(output.id) == "undefined") return false

        return true
      })

      return outputs
    },

    is_edit () {
      return typeof(this.event) != "undefined" && this.event.uuid != null;
    },
    is_clone () {
      var clone_id = this.$route.query.clone_id;
      return typeof(clone_id) != "undefined" && clone_id != null;
    },
    form () {
      var channel = ChannelModel.get_channel(this.output);
      if(!channel) return [];
      return (SettingsModel.get_by_name(channel.meta.event_form)||{}).value || {};
    },
    left_side () {
      return this.form.left
    },
    right_side () {
      return this.form.right
    },
    page_url () {
      if(!this.id) return;
      return EventModel.page_url(this.event)
    },
    calculatedDuration () {
      var val = this.calcDuration - this.event.offset;
      if(val < 0) return "-";
      return moment.duration(val, "seconds").format("h [hrs], m [min]")
    },
    calcDuration () {
      return moment(this.event.times.end_time).unix() - moment(this.event.times.start_time).unix()
    },
    sorted_inputs() {
      return _.sortBy(_.filter(this.inputs, (input) => { return input.state == "active"; }), "title");
    },
    sorted_outputs() {
      return _.sortBy(_.filter(this.outputs, (output) => { return output.state == "active"; }), "title");
    },
    output_channel() {
      return _.filter(this.outputs, (out) => { return out.id == this.output; });
    },
    output_is_transcoder() {
      var ch = this.output_channel[0];
      if (ChannelModel.is_transcoder(ch)) return true;
      return false;
    },

    alternatives () {
      if (this.source_is_alternatives == false) return [];
      var ret = ChannelModel.get_alternatives(this.event.event_group.channel_id);
      return _.map(ret, (alt) => {
        alt["title"] = ChannelModel.get_alternative_title(alt);
        return alt;
      });
    },

    source_is_alternatives() {
      var alternatives = ChannelModel.get_alternatives(this.event.event_group.channel_id);
      if (alternatives.length > 0) return true;
      return false;
    },
/*    source_outputs () {
      var channel = ChannelModel.channel_by_id(this.event.event_group.channel_id);
      if (typeof(channel) == "undefined") return [];
      if (typeof(channel.configuration.output) != "undefined") {
        return ChannelModel.outputs_list(channel);
      }
      return [];
    },*/
    output_inputs () {
      var channel = ChannelModel.channel_by_id(this.output);
      var inputs = _.get(channel, ["configuration","input"], {});
      var inputs_list = _.map(inputs, function(input, key) {
        input.id = key;
        if (typeof(input.title) == "undefined") {
          input.title = key;
        }
        return input;
      });
      inputs_list = _.filter(inputs_list, function(input) {
        if (input.id == "720p20") return false;
        if (input.id == "cloud1") return false;
        return true;
      });
      return _.sortBy(inputs_list, "title");
    },
    is_output_inputs () {
      var inputs = this.output_inputs;
      if (inputs.length > 1) return true;
      return false;
    },

    outputs_list() {
      // Get outputs from config and convert list/object type configurations into list
      let config = EventModel.render_channel_configuration(this.event, this.output)

      let outputs = _.get(config, "output.outputs", [])
      if (!_.isArray(outputs)) outputs = Object.values(outputs)

      return outputs
    },

    current_account_email () {
      if (typeof(this.current_account) != "undefined") {
        return this.current_account.email;
      }
      return undefined;
    },

    todo: {
      get: function() {
        return EventModel.is_todo_list(this.event, this.current_account);
      },
      set: function(newValue) {
        this._check_todo_data();
        Vue.set(this.event.event_group.system_meta.todos[this.current_account_email],'active', newValue);
      }
    },
    todo_status: {
       get: function() {
        return EventModel.todo_list_status(this.event, this.current_account);
      },
      set: function(newValue) {
        this._check_todo_data();
        Vue.set(this.event.event_group.system_meta.todos[this.current_account_email],'status', newValue);
      }
    },

    ...mapGetters({
      outputs: 'output_channels',
      inputs: 'input_channels'
    })
  },
  methods: {
    event_select_filter_events(events) {
      var self = this;
      if (self.event.uuid != null) {
        var is_linked = _.find(events, (event) => {
          if (_.get(event, ["system_meta", "linked_event"]) == self.event.uuid) return true;
          return false;
        });
        if (typeof(is_linked) != "undefined") {
          return [];
        }
      }
      return _.filter(events, (event) => {
        if (event.uuid == self.event.uuid) return false;
        if (_.get(event, ["system_meta", "linked_event"])) return false;
        return true;
      });
    },
    clear_route_alternative(input_name) {
      Vue.delete(this.event.system_meta.route_alternative, input_name);
    },
    channel_is_alternatives(channel) {
      var alternatives = ChannelModel.get_alternatives(channel);
      if (alternatives.length > 0) return true;
      return false;
    },

    clear_alternative() {
      Vue.delete(this.event.event_group.system_meta, "alternative");
    },
    clear_output_input() {
      Vue.delete(this.event.system_meta, "input");
      Vue.delete(this.event.system_meta, "linked_event");
    },
    channel_alternatives (channel) {
      if (this.channel_is_alternatives(channel) == false) return [];
      var ret = ChannelModel.get_alternatives(channel);
      return _.map(ret, (alt) => {
        alt["title"] = ChannelModel.get_alternative_title(alt);
        return alt;
      });
    },
   _check_todo_data() {
        if (typeof(this.event.event_group.system_meta) == "undefined" || this.event.event_group.system_meta == null) {
          Vue.set(this.event.event_group, "system_meta", {});
        }
        if (typeof(this.event.event_group.system_meta.todos) == "undefined") {
          Vue.set(this.event.event_group.system_meta, "todos", {});
        }
        if (typeof(this.event.event_group.system_meta.todos[this.current_account_email]) == "undefined")
        {
          Vue.set(this.event.event_group.system_meta.todos, this.current_account_email, {});
        }
    },
    get_channel (route, id = this.id) {
      var clone_id = route.query.clone_id;
      if (typeof(clone_id) != "undefined" && clone_id != null) {
        return "events:clone:"+clone_id;
      }
      return "events:"+(id||(clone_id ? "clone:"+clone_id : (this.event_group ? "create_with_group:"+this.event_group : "create" )));
    },
    convertEvent: function(newVal, oldVal) {
      var event = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }

      if (typeof(event) == "undefined" || _.isEmpty(event)) return undefined;

      // Cloned event keeps the source and alternative of the original event
      if (this.is_clone) {
        var source_channel = this.$route.query.source_channel;
        event.event_group.channel_id = /^\d+$/.test(source_channel) ? parseInt(source_channel, 10) : source_channel;
        if (_.isEmpty(event.event_group.system_meta)) event.event_group.system_meta = {};
        event.event_group.system_meta.alternative = this.$route.query.source_alternative;
      }

      var start_time = moment.unix(event.event_group.start_time).toDate();
      if (!_.isEmpty(this.id) || this.is_clone) {
        var end_time = moment.unix((event.cached_end_time || (event.event_group.start_time+event.duration))).toDate();
      } else {
        var end_time = start_time;
      }

      var publish_start_time = moment.unix(event.publish_start_time).toDate();
      var publish_end_time = moment.unix(event.publish_end_time).toDate();

      event.times = {
        "start_time": start_time,
        "end_time": end_time,
        "publish_start_time": publish_start_time,
        "publish_end_time": publish_end_time
      }
      this.output = event.channel_id;

      if (_.isEmpty(event.system_meta)) {
        event.system_meta = {};
      }

      if (_.isEmpty(event.system_meta.billing)) {
        event.system_meta.billing = {};
      }
      if (this.is_clone) {
        delete event.system_meta.billing.status;
      }
      if (_.isEmpty(event.system_meta.route_channel)) {
        event.system_meta.route_channel = {};
      }
      if (_.isEmpty(event.system_meta.route_alternative)) {
        event.system_meta.route_alternative = {};
      }
      if (_.isEmpty(event.system_meta.srt_latency)) {
        event.system_meta.srt_latency = {};
      }

      return event;
    },
    row_classes(childs) {
      return "xs" + Math.round(12/childs.length);
    },
    reset () {
      this.event = this.convertEvent(this.ws_channel.data);
    },
    changeState (state) {
      this.event.state = state;
      this.save(false);
    },
    clone () {
      var uuid = this.id || (this.event && this.event.uuid);
      this.$router.push({name: this.$route.meta.new || this.$route.name, query: {
        ...this.$route.query,
        tab: "event",
        clone_id: uuid,
        source_channel: _.get(this.event, ["event_group", "channel_id"]),
        source_alternative: _.get(this.event, ["event_group", "system_meta", "alternative"])
      }})
    },
    save (type) {
/*      if (!this.$refs.form.validate()) {
        return;
      }*/
      if (!this.$refs.end_time.validate()) {
        return;
      }
      if(typeof(this.ws_channel) != "undefined") {

        var self = this;
        var event = _.cloneDeep(this.event);

        if(!this.output) {
          if (typeof(event.uuid) == "undefined" || event.uuid == null) {
            self.$message.warning("Unable to create event. Destination missing!");
          } else {
            self.$message.warning("Unable to update event. Destination missing!");
          }
          return;
        }

        if(typeof(event.event_group.channel_id) == "undefined") event.event_group.channel_id = null;
        event.event_group.events = null;
        event.event_group.start_time = moment(this.event.times.start_time).unix()
        event.publish_start_time = moment(this.event.times.publish_start_time).unix()
        event.publish_end_time = moment(this.event.times.publish_end_time).unix()
        event.duration = this.calcDuration;
        event.channel_id = this.output;

        delete event.times;

        this.ws_channel.save({event: event}, (type != "new"))
          .then((msg) => {
            if (typeof(event.uuid) == "undefined" || event.uuid == null) {
              self.$message.success("Event was created!");
            } else {
              self.$message.success("Event was updated!");
            }
            if(type == "close") {
              self.$root.close_bottom_sheet();
            } else if (type == "new") {
              self.reset();
            } else if(typeof(this.$route.meta.edit) != "undefined") {
              // On the "new event" route (including clones) move to the saved event's edit route
              var new_uuid = _.get(msg, "data.uuid");
              if (new_uuid) {
                this.$router.push({name: this.$route.meta.edit, params: {id: new_uuid}})
              }
            }
          })
          .catch((msg) => {
            console.log(msg);
            if (typeof(event.uuid) == "undefined" || event.uuid == null) {
              self.$message.warning("Unable to create event!");
            } else {
              self.$message.warning("Unable to update event!");
            }
          });
      }
    }
  }
}
</script>
